import { faPencilAlt } from "@jewlr/pro-solid-svg-icons/faPencilAlt"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Image,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"
import styled from "styled-components"

import GreetingCardModal from "areas/cart/line-item/gift-wrap/greeting-card-modal"

const EditGreetingButton = styled(Button).attrs({
  color: "primary",
  mt: 1,
  underline: true,
  variant: "text",
})`
  font-size: 12px;
  letter-spacing: -0.03em;
  line-height: 14px;
`

const PreviewText = styled(Typography)`
  font-size: 14px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 16px;
  white-space: pre-wrap;
`

const AddonItem = ({ addonItem, lineItems, handleGreetingCard }) => {
  const [toggleModal, setToggleModal] = useState(false)
  const lineItem = lineItems.find(({ id }) => id === addonItem.lid)

  let selectedCardOption = null

  if (addonItem.addon_type === "GREETING_CARD") {
    selectedCardOption = lineItem.greeting_card_options.find(
      (card) => card.addon_code === addonItem.addon_code
    )
  }

  return (
    <Box key={`${addonItem.id}-${addonItem.addon_type}`} my={2}>
      <Flex alignItems="center" gap={{ _: 1, desktop: "12px" }}>
        <Image
          alt={addonItem.title}
          height="80px"
          src={addonItem.image_url}
          width="80px"
        />
        <Box>
          <Typography
            fontSize="16px"
            fontWeight="500"
            letterSpacing="-0.02em"
            lineHeight="20px"
          >
            {addonItem.title}
          </Typography>
          {addonItem.addon_type === "GREETING_CARD" && (
            <EditGreetingButton
              onClick={() => setToggleModal(true)}
              startIcon={
                <FontAwesomeIcon
                  color="primary"
                  fontSize="10px"
                  icon={faPencilAlt}
                  style={{ verticalAlign: "baseline" }}
                />
              }
            >
              Edit Greeting
            </EditGreetingButton>
          )}
        </Box>
      </Flex>
      {addonItem.addon_type === "GREETING_CARD" && (
        <>
          <Box pt={1} width={{ _: "100%", desktop: "447px" }}>
            {addonItem.recipient && (
              <PreviewText>{addonItem.recipient}</PreviewText>
            )}
            {addonItem.message && (
              <PreviewText>{addonItem.message}</PreviewText>
            )}
            {addonItem.sender && <PreviewText>{addonItem.sender}</PreviewText>}
          </Box>
          <GreetingCardModal
            greetingCardProps={addonItem}
            handleGreetingCard={(card, callbacks) =>
              handleGreetingCard(lineItem, card, callbacks)
            }
            onClose={() => setToggleModal(false)}
            selectedCardOption={selectedCardOption}
            show={toggleModal}
          />
        </>
      )}
    </Box>
  )
}

AddonItem.propTypes = {
  addonItem: PropTypes.object,
  handleGreetingCard: PropTypes.func,
  lineItems: PropTypes.array,
}

export default AddonItem
